import React from "react";
import "../../LGUrdu/styles.css";
import Logo from "../../../assets/logoWhite.png";
import data from "..//Data/Data";
import { useParams, Link, NavLink } from "react-router-dom";
import parse from "html-react-parser";
import "../../../ReUseAbleComp/styles.css";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { GiHamburgerMenu } from "react-icons/gi";
import Tooltip from "@mui/material/Tooltip";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";

const LGEnglishDetails = () => {
  const [state, setState] = React.useState({
    right: false,
  });

  const [dataListObj, setDataListObj] = React.useState({});
  const [audioLink, setAudioLink] = React.useState("");
  const audioRef = React.useRef(null);
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Divider />
    </Box>
  );
  const { Id } = useParams();
  React.useEffect(() => {
    function filterById(ids) {
      return data.filter((obj) => {
        return obj.id === ids;
      });
    }
    let dataList = filterById(parseInt(Id));
    console.log("datalist", dataList);
    setDataListObj(dataList[0]);
    setAudioLink(dataList[0].Pashtoaudio);
    audioRef.current.pause();
    audioRef.current.load();
  }, [Id]);

  React.useEffect(() => {
    toast.info("ډیفالټ ژبه پښتو ته ټاکل شوې", {
      position: "top-left",
      autoClose: 3000,
      hideProgressBar: false,
      pauseOnHover: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined,
    });
  }, []);
  if (!dataListObj) return <div>Data Not Found</div>;
  return (
    <>
      <Helmet>
        <title>{dataListObj.Ptitle}</title>
      </Helmet>
      <ToastContainer />
      <div className="mix_lang_header">
        <Link to="/">
          <img src={Logo} alt="lang_header_logo" className="mix_lang_logo" />
        </Link>
        <div className="socialIcons">
          <Link className="urdu" to={`/CovidEngTopicsDetails/${Id}`}>
            Eng
          </Link>
          <Link className="urdu" to={`/CovidUrduDetails/${Id}`}>
            اردو
          </Link>
          <NavLink
            className="urdu"
            to={`/CovidPashtoDetails/${Id}`}
            activeClassName="active-lang"
          >
            pashto
          </NavLink>
        </div>
      </div>

      <div id="outer-container">
        <div id="content">
          <h1 className="main_title-urdu">{dataListObj.Ptitle}</h1>
          <p className="main_Exp-urdu">
            {typeof dataListObj.pashtoDesc === "string" &&
              parse(dataListObj.pashtoDesc)}
          </p>
          <audio ref={audioRef} controls className="audio">
            <source src={audioLink} type="audio/mp3" />
          </audio>
        </div>

        <div id="sidebar">
          {data.map((list) => (
            <Tooltip title={list.Ptitle} arrow>
              <NavLink
                key={list.id}
                to={`/CovidPashtoDetails/${list.id}`}
                className="sidebar-btn-urdu"
                activeClassName="active-btn"
              >
                <span className="sidebar-btn-icon-urdu">{list.RID}</span>
                <span className="sidebar-btn-text-urdu">
                  {`${list.Ptitle.substring(0, 28)}..`}
                </span>
              </NavLink>
            </Tooltip>
          ))}
        </div>
      </div>

      <div className="ToggleSidebar">
        {["right"].map((anchor) => (
          <React.Fragment key={anchor}>
            <Drawer
              className="toggleSideBar"
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
            >
              <span
                className="ToggleBtnClose"
                onClick={toggleDrawer(anchor, false)}
              >
                X
              </span>
              {data.map((list) => (
                <Tooltip title={list.Ptitle} arrow>
                  <NavLink
                    key={list.id}
                    to={`/CovidPashtoDetails/${list.id}`}
                    onClick={toggleDrawer(anchor, false)}
                    className="sidebar-btn-urdu"
                    activeClassName="active-btn"
                  >
                    <span className="sidebar-btn-icon-urdu">{list.RID}</span>
                    <span className="sidebar-btn-text-urdu">
                      {`${list.Ptitle.substring(0, 28)}..`}
                    </span>
                  </NavLink>
                </Tooltip>
              ))}
            </Drawer>
            <span
              className="ToggleBtnUrdu"
              onClick={toggleDrawer(anchor, true)}
            >
              <GiHamburgerMenu />
            </span>
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default LGEnglishDetails;
